import xhr, { XhrResponse } from 'xhr';

interface IMakePostRequestParam {
    url: string; // URL to make the request to
    body: object; // Body of the request
}

// Make a promise based post request
export const makePostRequest = ({
    url,
    body,
}: IMakePostRequestParam): Promise<Error | XhrResponse> =>
    new Promise((resolve, reject) =>
        xhr.post(
            {
                url,
                body,
                json: true,
                timeout: 20000,
            },
            (err: Error, resp: XhrResponse) => {
                if (err) {
                    reject(err);
                } else if (resp.statusCode !== 200) {
                    reject(resp);
                } else {
                    resolve(resp);
                }
            },
        ),
    );
